// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__7AruQ","copy":"Footer_copy__RgW66","footlinks":"Footer_footlinks__tA83I"};